/* eslint-disable no-console */
import { rootApi } from '../rootApi';

// Helper function to get current language ID
const getCurrentLanguageIdFromParams = (params) => {
  // If LanguageId is explicitly provided, use it
  if (params?.LanguageId !== undefined) {
    return params.LanguageId;
  }
  // Default fallback
  return 1;
};

export const faultcodesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMainCategories: builder.query({
      query: (params) => {
        const queryParams = {
          LanguageId: getCurrentLanguageIdFromParams(params),
          SearchText: params?.SearchText || '',
          PageNumber: params?.PageNumber !== undefined ? params.PageNumber : 1,
          PageSize: params?.PageSize !== undefined ? params.PageSize : 100,
        };
        return {
          url: 'v1/faultcodes/getmaincategories',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {
        if (response.data.items && Array.isArray(response.data.items)) {
          const totalCount = response.data.totalCount !== undefined ? response.data.totalCount : response.data.length;
          return { data: response.data.items, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled, dispatch, getState }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getMainCategories - Query Failed:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getSecondCategories: builder.query({
      query: (params) => {
        const queryParams = {
          LanguageId: getCurrentLanguageIdFromParams(params),
          SearchText: params?.SearchText || '',
          mainCategory: params.mainCategory,
          PageNumber: params?.PageNumber !== undefined ? params.PageNumber : 1,
          PageSize: params?.PageSize !== undefined ? params.PageSize : 10,
        };
        return {
          url: 'v1/faultcodes/getsecondcategories',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {

        if (response.data.items && Array.isArray(response.data.items)) {
          const totalCount = response.data.totalCount !== undefined ? response.data.totalCount : response.data.length;
          return { data: response.data.items, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getSecondCategories - Query Failed:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getSubCategories: builder.query({
      query: (params) => {

        const queryParams = {
          LanguageId: getCurrentLanguageIdFromParams(params),
          SearchText: params?.SearchText || '',
          mainCategory: params.mainCategory,
          secondaryCategory: params.secondaryCategory,
          PageNumber: params?.PageNumber !== undefined ? params.PageNumber : 1,
          PageSize: params?.PageSize !== undefined ? params.PageSize : 10,
        };
        return {
          url: 'v1/faultcodes/getsubcategories',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {
        if (response.data.items && Array.isArray(response.data.items)) {
          const totalCount = response.data.totalCount !== undefined ? response.data.totalCount : response.data.length;
          return { data: response.data.items, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getSubCategories - Query Failed:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getSubPartCategories: builder.query({
      query: (params) => {
        const queryParams = {
          LanguageId: getCurrentLanguageIdFromParams(params),
          SearchText: params?.SearchText || '',
          mainCategory: params.mainCategory,
          secondaryCategory: params.secondaryCategory,
          subCategory: params.subCategory,
          PageNumber: params?.PageNumber !== undefined ? params.PageNumber : 1,
          PageSize: params?.PageSize !== undefined ? params.PageSize : 10,

        };
        return {
          url: 'v1/faultcodes/getsubpartcategories',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {
        if (response.data.items && Array.isArray(response.data.items)) {
          const totalCount = response.data.totalCount !== undefined ? response.data.totalCount : response.data.length;
          return { data: response.data.items, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getSubPartCategories - Query Failed:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getFailureModesCategory: builder.query({
      query: (params) => {
        const queryParams = {
          LanguageId: getCurrentLanguageIdFromParams(params),
          SearchText: params?.SearchText || '',
          PageNumber: params?.PageNumber !== undefined ? params.PageNumber : 1,
          PageSize: params?.PageSize !== undefined ? params.PageSize : 10,
        };
        return {
          url: 'v1/faultcodes/getfaultmodes',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {
        if (response.data.items && Array.isArray(response.data.items)) {
          const totalCount = response.data.totalCount !== undefined ? response.data.totalCount : response.data.length;
          return { data: response.data.items, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled, dispatch, getState }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getMainCategories - Query Failed:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getTranslationList: builder.query({
      query: (params) => {
        const queryParams = {};

        if (params?.translationId != null) {
          queryParams.translationId = params.translationId;
        }

        console.log('🚀 getTranslationList - Query Params (URL Parametreleri olarak gönderilecek):', queryParams);

        return {
          url: 'v1/faultcodes/gettranslationlist',
          params: queryParams
        };
      },
      transformResponse: (response, meta, arg) => {
        if (response && typeof response === 'object' && response.data && Array.isArray(response.data)) {
          const totalCount = response.totalCount !== undefined ? response.totalCount : response.data.length;
          return { data: response.data, totalCount: totalCount };
        }
        if (Array.isArray(response)) {
          return { data: response, totalCount: response.length };
        }
        return { data: [], totalCount: 0 };
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log('✅ getTranslationList - Sorgu Başarılı. Dönüştürülen Veri:', data);
        } catch (error) {
          console.error('❌ getTranslationList - Sorgu Başarısız:', error);
        }
      },
      providesTags: ['FaultCodes']
    }),

    getCategoryById: builder.query({
      query: (id) => {
        return `v1/faultcodes/GetById?id=${id}`;
      },
      transformResponse: (response, meta, arg) => {

        if (response && typeof response === 'object' && response.data) { // Tek bir obje dönebilir, dizi değil
          if (Array.isArray(response.data) && response.data.length > 0) {
            return { data: response.data[0], totalCount: 1 }; // Veya API'nin yapısına göre
          }
          if (!Array.isArray(response.data)) {
            return { data: response.data, totalCount: 1 }; // Veya API'nin yapısına göre
          }
        }
        if (response && typeof response === 'object' && !response.data) {
          return { data: response, totalCount: 1 };
        }
        return { data: null, totalCount: 0 }; // Tekil kayıt için null veya boş obje daha uygun olabilir
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
        } catch (error) {
          console.error('❌ getCategoryById - Query Failed:', error);
        }
      }
      // providesTags: (result, error, id) => [{ type: 'FaultCodes', id }], // Eğer tekil bir kaynağı etiketlemek isterseniz
    }),

    deleteFaultCodes: builder.mutation({
      query: (id) => ({
        url: `v1/faultcodes/deletebyid`,
        method: 'DELETE',
        params: { Id: id }
      }),
      invalidatesTags: ['FaultCodes']
    }),

    updateMainCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/updatemaincategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    updateSecondCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/updatesecondcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    updateSubCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/updatesubcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    updateSubPartCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/updatesubpartcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    updateFailureModesCategory: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/updatefaultmodes',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),

    addMainCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/savemaincategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    addSecondCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/savesecondcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    addSubCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/savesubcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    addSubPartCategories: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/savesubpartcategories',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),
    addFailureModesCategory: builder.mutation({
      query: (data) => ({
        url: 'v1/faultcodes/savefaultmodes',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FaultCodes']
    }),

    exportFaultCodesToExcel: builder.query({
      query: (params = {}) => {
        const queryParams = {
          RequestType: params.RequestType,
          LanguageId: getCurrentLanguageIdFromParams(params),
          CompressionType: params.CompressionType ?? 0,
        };
        if (params.MainCategory != null) queryParams.MainCategory = params.MainCategory;
        if (params.SecondaryCategory != null) queryParams.SecondaryCategory = params.SecondaryCategory;
        if (params.SubCategory != null) queryParams.SubCategory = params.SubCategory;
        if (params.SubPartCategory != null) queryParams.SubPartCategory = params.SubPartCategory;
        if (params.SearchText) queryParams.SearchText = params.SearchText;
        return {
          url: 'v1/faultcodes/ExportToExcel',
          method: 'GET',
          params: queryParams
        };
      },
      transformResponse: (response) => {
        if (response?.isSuccessful && response?.data) {
          const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
          return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
        }
        throw new Error(response?.errorMessage || response?.message || 'Export başarısız oldu');
      }
    }),

  })
});

export const {
  useGetMainCategoriesQuery,
  useGetSecondCategoriesQuery,
  useGetSubCategoriesQuery,
  useGetSubPartCategoriesQuery,
  useGetTranslationListQuery,
  useGetFailureModesCategoryQuery,
  useUpdateMainCategoriesMutation,
  useUpdateSecondCategoriesMutation,
  useUpdateSubCategoriesMutation,
  useUpdateSubPartCategoriesMutation,
  useUpdateFailureModesCategoryMutation,
  useAddMainCategoriesMutation,
  useAddSecondCategoriesMutation,
  useAddSubCategoriesMutation,
  useAddSubPartCategoriesMutation,
  useAddFailureModesCategoryMutation,
  useGetCategoryByIdQuery,
  useDeleteFaultCodesMutation,
  useLazyExportFaultCodesToExcelQuery
} = faultcodesApi;